<div class="terms-content-panel">
  <div id="terms_and_conditions" class="p-[1rem] flex flex-col items-center">
    <div class="w-full max-w-xl">
      <div *ngIf="loading" class="flex flex-col p-10 gap-2 items-center">
          <mat-progress-spinner diameter="30" mode="indeterminate" color="primary"></mat-progress-spinner>
      </div>
      <div *ngIf="!loading" class="max-w-xl overflow-y-auto" [innerHTML]="texts.terms_and_conditions" ></div>
    </div>
  </div>
  <div class="dialog-actions">
    <ng-container *ngIf="funderStyles && !loading">
      <button 
        [style.border-radius]="funderStyles.btnRound + 'px'"
        class="px-8 bg-slate-300/30" 
        mat-flat-button 
        (click)="onCancel()"
      >{{texts.cancel}}</button>
      <button         
        [style.color]="funderStyles.colors?.btnText"
        [style.background]="funderStyles.colors?.btnBg"
        [style.border-radius]="funderStyles.btnRound + 'px'"
        class="px-8" 
        mat-flat-button 
        type="button" 
        cdkFocusInitial
        (click)="onAccept()"
      >{{texts.accept}}</button>
    </ng-container>
  </div>
</div>
